"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editModeOnly = void 0;
var editModeOnly = function (style) {
    return "\n    .is-edit-mode-active & {\n      ".concat(style, "\n    }\n  ");
};
exports.editModeOnly = editModeOnly;
